module.exports = __webpack_public_path__ + "img/image.15cd2529.jpg";